import { Controller } from "@hotwired/stimulus"

// Gesso remembers the sidebar in the browser, which outlasts the person
// using it. These are the gem's keys, private to its own controller: an
// engine cannot know what signing in means to its host, so the clearing
// belongs here, on every page that stands outside a session.
const SIDEBAR_KEYS = [ "sidebar-collapsed", "sidebar-groups-open" ]

export default class extends Controller {
  connect() {
    try {
      SIDEBAR_KEYS.forEach((key) => localStorage.removeItem(key))
    } catch {
      // A browser that refuses storage has nothing remembered to forget.
    }
  }
}
